import { render } from "./DataGenerator.vue?vue&type=template&id=141f8500&scoped=true"
import script from "./DataGenerator.vue?vue&type=script&lang=js"
export * from "./DataGenerator.vue?vue&type=script&lang=js"

import "./DataGenerator.vue?vue&type=style&index=0&id=141f8500&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141f8500"]])

export default __exports__